import { CatalogPageQuerykeys } from '@enums/react-query-keys';
import { CatalogGuidedSearchResponse } from '@interfaces/api/responses/catalog-page-guided-search-response';
import { CatalogContext } from '@context/catalog.context';
import { useContextSelector } from 'use-context-selector';
import { useQuery } from '@tanstack/react-query';

type UseGuidedSearchQueryType = {
  guidedSearch: CatalogGuidedSearchResponse;
  showCarousel: boolean;
};

const useGuidedSearchQuery = (): UseGuidedSearchQueryType => {
  const { data: guidedSearch } = useQuery<CatalogGuidedSearchResponse>({
    queryKey: [CatalogPageQuerykeys.GET_GUIDED_SEARCH],
    staleTime: Infinity,
  });

  // Determine whether to show the static guided search
  const enableTaxonomyGuidedSearch = useContextSelector(CatalogContext, (v) => v.enableTaxonomyGuidedSearch);
  const queryResult = useContextSelector(CatalogContext, (v) => v.queryResult);

  // Don't show carousel until API response is received
  // Show carousel only if taxonomy guided search is disabled and there are items to show
  const hasApiResponse = !!queryResult;
  const showCarousel = hasApiResponse && enableTaxonomyGuidedSearch === false && guidedSearch?.items?.length > 0;

  return {
    guidedSearch,
    showCarousel,
  };
};
export default useGuidedSearchQuery;
